import React, { useCallback, useMemo } from 'react';
import { useHistory, useLocation, Route, Switch, Redirect } from 'react-router-dom';

import navbarReduce from '../../shared/data/navbar/navbarReduce';
import Page from 'Components/Page';
import TabLeaveRequest from './components/TabLeaveRequest';
import TabHistory from './components/TabHistory';
import withAuthentication from 'Components/withAuthentication';
import TabAllocations from './components/TabAllocations/TabAllocations';
import ReactGA from 'Shared/analytics';

const Vacations = ({ profileData }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const tabRouter = (
    <>
      <Route path="/employee/vacations/" exact render={() => <Redirect to="/employee/vacations/leave-request/" />} />
      <Switch>
        <Route path="/employee/vacations/leave-request/" component={TabLeaveRequest} />
        <Route path="/employee/vacations/history/" component={TabHistory} />
        <Route path="/employee/vacations/allocations/" component={TabAllocations} />
      </Switch>
    </>
  );

  const activeTabId = useMemo(() => {
    return pathname.split('/')[3];
  }, [pathname]);

  const handleTabClick = useCallback(
    (tabClicked) => {
      if (tabClicked !== activeTabId) {
        history.replace(`/employee/vacations/${tabClicked}/`);
        ReactGA.pageview(`/employee/vacations/${tabClicked}/`, 'Vacations' + tabClicked);
      }
    },
    [history, activeTabId]
  );

  return (
    <Page
      props={{
        titleProps: {
          text: 'Vacations',
        },
        navigation: {
          variant: 'tabs',
          tabsProps: {
            tabs: [
              {
                id: 'leave-request',
                label: 'LEAVE REQUEST',
              },
              {
                id: 'history',
                label: 'HISTORY',
              },
              {
                id: 'allocations',
                label: 'ALLOCATIONS',
              },
            ],
            onTabClick: handleTabClick,
            activeTabId,
          },
        },
        navbarProps: {
          points: navbarReduce(profileData),
          activePointId: 'vacations',
        },
        content: tabRouter,
      }}
    />
  );
};

export default withAuthentication(Vacations);
